import * as React from 'react';
import { Link } from '@core-ds/icons/16';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';

export const LinkButton = props => {
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().editLink().run()}
         isDisabled={!editor.can().editLink()}
         isActive={editor.isActive('link')}
         icon={<Link />}
         title={_js('Insert a link')}
         shortcut={'k'}
      />
   );
};
